module.exports = __webpack_public_path__ + "img/logo2.b220f61d.png";